import './load.css'

const Load = ({load}) => {

      if(load.length !== 0) return 

      return (
            <div className="load_content">
                  <div className="load_circle"></div>
                  <span>Wait Loading...</span>
            </div>
      )
}

export default Load
